import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
      alert('Thank you for your message! We\'ll get back to you soon.');
    }, 2000);
  };

  const contactInfo = [
    {
      icon: '📍',
      title: 'Address',
      content: 'NH-2 , Near Ashok Leyland,Ajrakwe Hasauli,Aurangabaad,Bihar 824101,India',
      type: 'address'
    },
    {
      icon: '📞',
      title: 'Phone',
      content: '+91 8340539463',
      type: 'phone'
    },
    {
      icon: '✉️',
      title: 'Email',
      content: 'sangamluxurious@gmail.com',
      type: 'email'
    },
    {
      icon: '🕒',
      title: 'Hours',
      content: 'Mon - Sun: 6:00 AM - 10:00 PM',
      type: 'hours'
    }
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="contact-header">
        <div className="header-background"></div>
        <div className="header-content">
          <div className="header-badge">
            <span className="badge-text">🤝 Get In Touch</span>
          </div>
          <h1 className="header-title">Contact Us</h1>
          <p className="header-subtitle">We'd love to hear from you and help make your dream getaway a reality!</p>
        </div>
      </div>

      {/* Contact Container */}
      <div className="contact-container">
        <div className="container-wrapper">
          {/* Contact Info */}
          <div className="contact-info">
            <div className="info-header">
              <span className="section-label">Reach Out</span>
              <h2 className="section-title">Get in Touch</h2>
              <p className="section-subtitle">
                Ready to plan your perfect getaway? We're here to help you every step of the way.
              </p>
            </div>

            <div className="info-grid">
              {contactInfo.map((item, index) => (
                <div key={index} className="info-item">
                  <div className="info-icon">
                    <span>{item.icon}</span>
                  </div>
                  <div className="info-content">
                    <h3 className="info-title">{item.title}</h3>
                    <p className="info-text">{item.content}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="social-links">
              <h3 className="social-title">Follow Us</h3>
              <div className="social-icons">
                <a href="https://www.facebook.com/share/1JZKHzHCuC/" target='_blank' className="social-link">
                  <span className="social-icon">📘</span>
                  <span className="social-text">Facebook</span>
                </a>
                <a href="https://www.instagram.com/sangam_resort01?igsh=MXh4dWx4MzgzeG04Ng==" target='_blank' className="social-link">
                  <span className="social-icon">📷</span>
                  <span className="social-text">Instagram</span>
                </a>
                {/* <a href="#" className="social-link">
                  <span className="social-icon">🐦</span>
                  <span className="social-text">Twitter</span>
                </a> */}
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form">
            <div className="form-header">
              <span className="section-label">Message Us</span>
              <h2 className="section-title">Send Us a Message</h2>
              <p className="section-subtitle">
                Fill out the form below and we'll get back to you within 24 hours.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="form-container">
              <div className="form-group">
                <label htmlFor="name" className="form-label">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter your full name"
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone" className="form-label">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="Enter your phone number"
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows="6"
                  placeholder="Tell us about your requirements..."
                  className="form-textarea"
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className={`form-button ${isSubmitting ? 'submitting' : ''}`}
              >
                {isSubmitting ? (
                  <span className="button-content">
                    <span className="spinner"></span>
                    Sending...
                  </span>
                ) : (
                  <span className="button-content">
                    <span className="button-icon">📤</span>
                    Send Message
                  </span>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="contact-map">
        <div className="map-container">
          <div className="map-header">
            <span className="section-label">Location</span>
            <h2 className="section-title">Find Us on Map</h2>
            <p className="section-subtitle">
              Located in the heart of nature, our resort is easily accessible from Aurangabaad city.
            </p>
          </div>
          
          <div className="map-wrapper">

<iframe  title="Sangam Resort & Banquet" 
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3623.8120717685842!2d84.41271757542073!3d24.733331278012542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398cfd0077ce266f%3A0xbb490411d1dbdd87!2sSangam%20Resort%20%26%20Banquet%20Hall!5e0!3m2!1sen!2sin!4v1752599913783!5m2!1sen!2sin"
   allowfullscreen=""
    loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"
     className="map-iframe"
    ></iframe>
            <div className="map-overlay">
              <div className="map-info">
                <h3 className="map-title"> Resorts</h3>
                <p className="map-address">Aurangabadd Bihar, India</p>
                <a href="#" className="map-directions">
                  <span className="directions-icon">🧭</span>
                  Get Directions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;